import { createFileRoute } from "@tanstack/react-router";
import { VocabularyPage } from "@/components/vocabulary/vocabulary-page.js";

export const Route = createFileRoute("/_authenticated/catalog/vocabulary")({
  component: VocabularyPage,
});
